import { useTranslation } from 'next-i18next';
import { useAlertDialog } from './useAlertDialog';
export function useUnknownErrorDialog() {
  const {
    t
  } = useTranslation(['common']);
  const alertDialog = useAlertDialog();
  const open = async () => {
    return await alertDialog.open({
      // TODO: shared로 사용되는 코드이므로 common.unknownErrorDialog.title 로 변경 필요. 크게 문제가 되는 건 아니라서 일단 둡니다.
      title: t('googleClassroom.unknownErrorDialog.title'),
      content: t('googleClassroom.unknownErrorDialog.content')
    });
  };
  return {
    open,
    didOpen: alertDialog.didOpen
  };
}